import { ResolverContext } from '../types';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { trelloFetch } from '@trello/fetch';
import { QueryBoardAccessRequestableArgs } from '../generated';
import { parseNetworkError } from '@trello/graphql-error-handling';

export const boardAccessRequestableResolver = async (
  _parent: unknown,
  args: QueryBoardAccessRequestableArgs | null,
  context: ResolverContext,
  info: QueryInfo,
) => {
  const { modelType, id } = args || {};
  const apiUrl = `/1/${modelType}/${id}/requestAccess`;
  const response = await trelloFetch(
    apiUrl,
    {
      credentials: 'same-origin',
    },
    {
      clientVersion: context.clientAwareness.version,
      networkRequestEventAttributes: {
        source: 'graphql',
        resolver: 'RequestAccess.boardAccessRequestable',
        operationName: context.operationName,
      },
    },
  );

  const statusCode = response.status;
  let requestable = {
    requested: false,
  };
  if (!response.ok) {
    if (statusCode === 429) {
      requestable = {
        requested: true,
      };
    } else {
      throw await parseNetworkError(response);
    }
  }

  return prepareDataForApolloCache(requestable, info);
};
